export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.BASE_URL || '/'}sw.js`).catch((error) => {
      console.warn('Service Worker注册失败:', error)
    })
  })
}
